import { BASE_URL, VENDOR_ASSESSMENT_QUESTION_OPTION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IVendorAssessmentQuestionOptionInput } from "models/vendorAssessmentQuestionOption";


export async function getVendorAssessmentQuestionOptions(params: string = "") {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_QUESTION_OPTION + params);
  return response.data;
}
export async function addVendorAssessmentQuestionOption(data: IVendorAssessmentQuestionOptionInput) {
  const response = await axios.post(BASE_URL + VENDOR_ASSESSMENT_QUESTION_OPTION, data);
  return response.data;
}
export async function editVendorAssessmentQuestionOption(data: IVendorAssessmentQuestionOptionInput, id: string) {
  const response = await axios.patch(BASE_URL + VENDOR_ASSESSMENT_QUESTION_OPTION + "/" + id, data);
  return response.data;
}

export async function deleteVendorAssessmentQuestionOption(id: string) {
  const response = await axios.delete(BASE_URL + VENDOR_ASSESSMENT_QUESTION_OPTION + "/" + id);
  return response.data;
}

export const VendorAssessmentQuestionOptionCells: HeadCell[] = [

  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_ar",
  },
  {
    id: "score",
    numeric: true,
    disablePadding: false,
    label: "T_score",
  },
  {
    id: "optionOrder",
    numeric: true,
    disablePadding: false,
    label: "T_order",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
